import {API_GAME_INSTANCES, GAME_MOBILE_BRANCHIO_LINK, API_GAME_TEAM_DEFINITION, API_GAME} from '../../configs/apis';
import {
  GAME_LIST_REQUEST,
  GAME_LIST_SUCCESS,
  GAME_ABLY_UPDATED,
  GAME_ABLY_CREATED,
  ON_MODAL_OPEN,
  ON_MODAL_CLOSE,
  ABLY_GAME_HAS_STARTED,
  ABLY_GAME_ROUND_FINISHED,
  ABLY_GAME_ROUND_STARTED,
  ABLY_GAME_QUESTION_NEXT,
  ABLY_GAME_HAS_FINISHED,
  ABLY_GAME_INTERSTITIAL_STARTED,
  ABLY_GAME_INTERSTITIAL_FINISHED,
  ABLY_GAME_ADMIN_HAS_CHANGED,
  GAME_TEAM_DEFINITION_REQUEST,
  GAME_TEAM_DEFINITION_SUCCESS,
  GAME_MOBILE_BRANCHIO_LINK_REQUEST,
  GAME_MOBILE_BRANCHIO_LINK_SUCCESS,
  PLAYER_ENTERED_GAME_BY_DIRECT_LINK,
  ABLY_USER_IS_ONLINE,
  ABLY_USER_IS_OFFLINE,
  ABLY_GAME_RESPONDENT_HAS_BEEN_CHANGED,
  GAME_LANDING_SHOWED,
} from '../types';
import Api from '../../utils/api';
import {
  hideSavingOnButton,
  showSavingOnButton,
} from '../../components/common/Loaders/ButtonLoader';
import {handleError} from '../error';
import {forwardTo} from '../../utils';

export function landingShowed(gameId) {
  return async (dispatch) => {
    try {
      if (gameId) {
        forwardTo(`/game/${gameId}`);
      } else {
        forwardTo('/lobby');
      }
      return dispatch({type: GAME_LANDING_SHOWED});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function createGame(params, appId) {
  return async (dispatch) => {
    try {
      dispatch({type: ON_MODAL_OPEN});
      dispatch(showSavingOnButton());
      await Api.post(API_GAME_INSTANCES, params, {appId});
      return dispatch({type: ON_MODAL_CLOSE});
    } catch (error) {
      return dispatch(handleError(error));
    } finally {
      dispatch(hideSavingOnButton());
    }
  };
}

export function fetchGames(params) {
  return async (dispatch) => {
    try {
      const {appId, ...rest} = params;
      dispatch({type: GAME_LIST_REQUEST, ...params});
      const response = await Api.get(API_GAME_INSTANCES, rest, {appId});
      return dispatch({type: GAME_LIST_SUCCESS, response});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function onPlayerEnteredGameByDirectLink(params) {
  return async (dispatch) => {
    try {
      const {appId, gameId} = params;
      const response = await Api.get(API_GAME, {}, {appId, gameId});
      dispatch({type: PLAYER_ENTERED_GAME_BY_DIRECT_LINK, response});
      return response;
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function fetchTeamDefinition(params) {
  return async (dispatch) => {
    try {
      const {appId, gameId} = params;
      dispatch({type: GAME_TEAM_DEFINITION_REQUEST, ...params});
      const fields = await Api.get(API_GAME_TEAM_DEFINITION, {}, {appId, gameId});
      return dispatch({type: GAME_TEAM_DEFINITION_SUCCESS, fields});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function fetchMobileBranchIoLink(params) {
  return async (dispatch, getState) => {
    try {
      const {appId, gameId} = params;
      const {auth: {token}} = getState();

      dispatch({type: GAME_MOBILE_BRANCHIO_LINK_REQUEST, ...params});

      const {data: {url = false}} = await Api.post(
        GAME_MOBILE_BRANCHIO_LINK,
        {userToken: token}, {appId, gameId}
      );

      return dispatch({type: GAME_MOBILE_BRANCHIO_LINK_SUCCESS, url});
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function updateGame(message) {
  const {data: updatedGame} = message;
  return {
    type: GAME_ABLY_UPDATED,
    updatedGame,
  };
}

export function onGameCreated(message) {
  const {data: newGame} = message;
  return {
    type: GAME_ABLY_CREATED,
    newGame,
  };
}

export function onGameStart() {
  return {
    type: ABLY_GAME_HAS_STARTED,
  };
}

export function onGameQuestionNextMessage(data) {
  return {
    type: ABLY_GAME_QUESTION_NEXT,
    data,
  };
}

export function onGameHasFinished(data) {
  return {
    type: ABLY_GAME_HAS_FINISHED,
    data,
  };
}

export function onGameRoundFinished(message) {
  const {round} = message;
  return {
    type: ABLY_GAME_ROUND_FINISHED,
    round,
  };
}

export function onGameRoundStarted(message) {
  const {round} = message;
  return {
    type: ABLY_GAME_ROUND_STARTED,
    round,
  };
}

export function onInterstitialHasStarted(message) {
  const {interstitial = {}} = message;
  const {asset} = interstitial;
  return {
    type: ABLY_GAME_INTERSTITIAL_STARTED,
    asset,
  };
}

export function onInterstitialHasFinished() {
  return {
    type: ABLY_GAME_INTERSTITIAL_FINISHED,
  };
}

export function onPlayerOnline(data) {
  return {
    type: ABLY_USER_IS_ONLINE,
    data,
  };
}

export function onPlayerOffline(data) {
  return {
    type: ABLY_USER_IS_OFFLINE,
    data,
  };
}

export function onRespondentChanged(data) {
  return {
    type: ABLY_GAME_RESPONDENT_HAS_BEEN_CHANGED,
    data,
  };
}

export function onGameAdminChanged(data) {
  return {
    type: ABLY_GAME_ADMIN_HAS_CHANGED,
    data,
  };
}
